export const environment = {
  production: false,
  apiEndPoint: 'https://api.grapnel.cyberdome.org.in',
  datadog: {
    applicationId: '3650a7cd-1202-4fd4-a818-05dfb5520741',
    clientToken: 'pub9d73f269a4b85fb5072953d536c93c46',
    site: 'datadoghq.com',
    service: 'grapnel-dev',
    env: 'dev',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
  }
};
